import * as React from "react";
import {render} from "react-dom";
import {
    BrowserRouter as Router,
    Route
} from "react-router-dom";

import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import thunkMiddleware from "redux-thunk";
import "babel-polyfill";
import * as ReactGA from "react-ga";

import rootReducer from "./reducers/index";
import {loadLatestOrder} from "./actions/hotels";
import {loadConfig, loadTickets} from "./actions/common";
import Recaptcha from "./components/Recaptcha";
import Tickets from "./components/Tickets";
import Summary from "./components/Summary";
import Checkout from "./components/Checkout";
import Review from "./components/Review";
import Admin from "./components/admin";
import {Footer, Header} from "./components/Header";
import Confirm from "./components/Confirm";
import {parentFrameScrollToTop} from "./utils";
const ReactPixel = require("react-facebook-pixel").default;

ReactGA.initialize("UA-74040302-3");
const store = applyMiddleware(thunkMiddleware)(createStore)(rootReducer);

ReactPixel.init("1353515278149259");

store.dispatch(loadLatestOrder());
store.dispatch(loadConfig());
store.dispatch(loadTickets());

const logPageView = (): null => {
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
    parentFrameScrollToTop();
    ReactPixel.pageView();
    if (window.location.pathname.indexOf("confirm") > -1) {
        ReactPixel.track("Purchase", {value: 0});
    }
    return null;
};

render((
    <Provider store={store}>
        <Router basename="wdwtickets">
            <div className="container main-container">
                <Route path="/" component={logPageView} />
                <Recaptcha />
                <Header/>
                <Route exact path="/" component={Tickets} />
                <Route exact path="/tickets" component={Tickets} />
                <Route exact path="/summary" component={Summary} />
                <Route exact path="/checkout" component={Checkout} />
                <Route exact path="/review" component={Review} />
                <Route exact path="/confirm" component={Confirm} />
                <Route path="/admin" component={Admin} />
                <Footer/>
            </div>
        </Router>
    </Provider>), document.getElementById("app"));



// WEBPACK FOOTER //
// ./src/main.tsx